import API from "@/lib/API";

export const getInventorySettings = async (query = {}) => {
  const params = new URLSearchParams(query).toString();
  const res = await API.get(`/inventory/settings?${params}`);
  return res.data;
};

export const createInventorySetting = async (data) => {
  const res = await API.post("/inventory/settings", data);
  return res.data;
};

export const updateInventorySetting = async (id, data) => {
  const res = await API.patch(`/inventory/settings/${id}`, data);
  return res.data;
};

export const deleteInventorySetting = async (id, settingType) => {
  const params = new URLSearchParams({ settingType }).toString();
  const res = await API.delete(`/inventory/settings/${id}?${params}`);
  return res.data;
};

export const uploadItemImage = async (formData) => {
  const res = await API.post('/inventory/settings/images/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

// ─── Purchase services ──────────────────────────────────────────────────────
export const getPurchases = async (query = {}) => {
  const params = new URLSearchParams(query).toString();
  const res = await API.get(`/inventory/purchases?${params}`);
  return res.data;
};

export const deletePurchase = async (id) => {
  const res = await API.delete(`/inventory/purchases/${id}`);
  return res.data;
};

// ─── Sale services ──────────────────────────────────────────────────────────
export const getSales = async (query = {}) => {
  const params = new URLSearchParams(query).toString();
  const res = await API.get(`/inventory/sales?${params}`);
  return res.data;
};

export const deleteSale = async (id) => {
  const res = await API.delete(`/inventory/sales/${id}`);
  return res.data;
};

// ─── Purchase Return services ────────────────────────────────────────────────
export const getPurchaseReturns = async () => {
  const res = await API.get('/inventory/purchase-returns');
  return res.data;
};

export const deletePurchaseReturn = async (id) => {
  const res = await API.delete(`/inventory/purchase-returns/${id}`);
  return res.data;
};

// ─── Sale Return services ────────────────────────────────────────────────────
export const getSaleReturns = async () => {
  const res = await API.get('/inventory/sale-returns');
  return res.data;
};

export const deleteSaleReturn = async (id) => {
  const res = await API.delete(`/inventory/sale-returns/${id}`);
  return res.data;
};

// ─── Vendor Balance services ─────────────────────────────────────────────────
export const getVendorBalances = async (query = {}) => {
  const params = new URLSearchParams(query).toString();
  const res = await API.get(`/inventory/vendor-balance?${params}`);
  return res.data;
};

export const createVendorBalance = async (data) => {
  const res = await API.post('/inventory/vendor-balance', data);
  return res.data;
};

export const deleteVendorBalance = async (id) => {
  const res = await API.delete(`/inventory/vendor-balance/${id}`);
  return res.data;
};

// ─── Challan services ────────────────────────────────────────────────────────
export const getChallans = async () => {
  const res = await API.get('/inventory/challans');
  return res.data;
};

export const deleteChallan = async (id) => {
  const res = await API.delete(`/inventory/challans/${id}`);
  return res.data;
};

// ─── Shipping services ───────────────────────────────────────────────────────
export const getShipments = async () => {
  const res = await API.get('/inventory/shipping');
  return res.data;
};

export const deleteShipment = async (id) => {
  const res = await API.delete(`/inventory/shipping/${id}`);
  return res.data;
};
